import './Loading.css';

export const Loading = () => {
  return (
    <div className="rails-loading">
      <div className="lds-ripple">
        <div />
        <div />
      </div>
    </div>
  );
};
